import React from 'react'
import { BalanceOperationList } from './list/page'
export const BalanceOperationPage: React.FC = () => {
  return <BalanceOperationList />
}
